import SanitizeUtils from './SanitizeUtils';

export default class SessionUtils {
  static storeLoginTime () {
    localStorage.setItem('bookero-login-time', new Date().getTime());
  }

  static getLoginTime () {
    let loginTime = SanitizeUtils.getLocalStorageValue('bookero-login-time', 'integer', 0);

    if (!loginTime) {
      loginTime = new Date().getTime();
      localStorage.setItem('bookero-login-time', loginTime);
    }

    return loginTime;
  }

  static getDaysSinceLogin () {
    return Math.floor((new Date().getTime() - SessionUtils.getLoginTime()) / (24 * 60 * 60 * 1000));
  }

  static getHoursSinceLogin () {
    return Math.floor((new Date().getTime() - SessionUtils.getLoginTime()) / (60 * 60 * 1000));
  }
};



// WEBPACK FOOTER //
// ./src/components/helpers/SessionUtils.js